// extracted by mini-css-extract-plugin
export default {"top":"Header_top__yG7-z","header":"Header_header__gp-ro","headerPosition":"Header_headerPosition__PrxpH","lang":"Header_lang__FqSli","hide":"Header_hide__Anc34"};